export enum Roles {
  ADMINISTRATOR = 'ADMINISTRATOR',
  MERCHANT = 'MERCHANT',
  PARTNER = 'PARTNER',
  RESELLER = 'RESELLER',
  MERCHANT_BRANCH = 'MERCHANT_BRANCH',
  SETTLEMENT = 'SETTLEMENT',
  CHECKER = 'CHECKER',
}
